export const environment = {
  production: true,
  hmr: false,
  urlAPI: 'https://api.myposventa.es/api/',
  urlWeb: 'https://www.myposventa.es/',
  blobPublic: 'https://blobrenault.blob.core.windows.net/prod-renault-marketing-public/',
  authority: 'https://sso.renault.com/oauth2/aus133y6mks4ptDss417',
  clientId: 'irn-74472_ope_pkce_wqkjuxakqbdp',
  useSSO: true,
  issueTrackerKey: '313ded46-d944-49a5-8ba8-de1523a0e11a',
  issueTrackerUrl: 'https://issue-tracker.lnkgs.es/',
  urlApiSurvey: 'https://api-simsurvey.lnkgs.es/api/',
  chatbotKey: 'L1MoDP0ykPe6BLSR8jm5F37h9pQ1FtEBOUdoAsqJU5Crt8DLRaki09YaQnc',
  chatbotUrl: 'https://prod-chatbot.lnkgs.es/',
  urlWebRenaultManager:'https://prod-rm.lnkgs.es/',  
};
